import entities from "./entities/en";
import pages from "./pages/en";
import globals from "./globals/en";
import formValidation from "./formValidation/en";
import enums from "./enums/en";

export default { entities, pages, globals, formValidation, enums };
